import Input from '@/components/base/Input';
import { riyadhDistricts } from '@/mocks/districts';
import type { RegisterData } from '@/pages/auth/register/types';

interface StepLocationProps {
  data: RegisterData;
  errors: Partial<Record<keyof RegisterData, string>>;
  update: (key: keyof RegisterData, value: string) => void;
  toggleCoverage: (district: string) => void;
}

export default function StepLocation({
  data,
  errors,
  update,
  toggleCoverage,
}: StepLocationProps) {
  return (
    <div className="space-y-6">
      <div className="w-full">
        <p className="mb-2 font-medium text-[13px] text-foreground-800">موقع المغسلة على الخريطة</p>
        <div className="overflow-hidden rounded-card border border-background-200">
          <iframe
            title="خريطة موقع المغسلة"
            src="https://www.google.com/maps?q=Riyadh%20Saudi%20Arabia&output=embed"
            className="h-[240px] w-full"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        <p className="mt-1.5 flex items-center gap-1.5 text-[12px] text-foreground-400">
          <i className="ri-information-line text-sm" aria-hidden="true"></i>
          أدخل تفاصيل العنوان بدقة لتسهيل وصول المندوبين.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-3">
        <Input
          label="الحي"
          name="district"
          icon="ri-community-line"
          placeholder="مثال: العليا"
          value={data.district}
          error={errors.district}
          onChange={(event) => update('district', event.target.value)}
        />
        <Input
          label="الشارع"
          name="street"
          icon="ri-road-map-line"
          placeholder="اسم الشارع"
          value={data.street}
          error={errors.street}
          onChange={(event) => update('street', event.target.value)}
        />
        <Input
          label="رقم المبنى"
          name="buildingNo"
          icon="ri-building-2-line"
          placeholder="1234"
          value={data.buildingNo}
          error={errors.buildingNo}
          onChange={(event) => update('buildingNo', event.target.value)}
        />
      </div>

      <div className="w-full">
        <p className="mb-2 font-medium text-[13px] text-foreground-800">
          الأحياء التي تغطيها <span className="text-danger-500">*</span>
        </p>
        <div className="flex flex-wrap gap-2">
          {riyadhDistricts.map((district) => {
            const selected = data.coverage.includes(district);
            return (
              <button
                key={district}
                type="button"
                onClick={() => toggleCoverage(district)}
                className={[
                  'rounded-full border px-3 py-1.5 text-[13px] font-medium transition-colors',
                  selected
                    ? 'border-secondary-500 bg-secondary-500 text-white'
                    : 'border-background-300 bg-white text-foreground-700 hover:border-secondary-300 hover:bg-secondary-50',
                ].join(' ')}
              >
                {selected && <i className="ri-check-line me-1 text-sm" aria-hidden="true"></i>}
                {district}
              </button>
            );
          })}
        </div>
        {errors.coverage && (
          <p className="mt-1.5 text-[12px] text-danger-600">{errors.coverage}</p>
        )}
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        <Input
          label="أوقات العمل — من الساعة"
          name="openFrom"
          type="time"
          icon="ri-time-line"
          value={data.openFrom}
          onChange={(event) => update('openFrom', event.target.value)}
        />
        <Input
          label="أوقات العمل — إلى الساعة"
          name="openTo"
          type="time"
          icon="ri-time-line"
          value={data.openTo}
          onChange={(event) => update('openTo', event.target.value)}
        />
      </div>
    </div>
  );
}